import React, { useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { CSVLink } from "react-csv";
import axios from "axios";
import styled from "styled-components";

const ExportLinks = ({ project, bugs }) => {
  const [csvData, setCsvData] = useState([]);
  const [loading, setLoading] = useState(false);

  const generateCsv = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`/v1/projects/${project.id}/bugs.json`);
      const tickets = response.data.tickets || [];

      const data = [
        [
          "Ticket ID",
          "Title",
          "Assignee",
          "Reported By",
          "Devices",
          "Browsers",
          "Status",
        ],
      ];

      tickets.forEach((bug) => {
        const ticketId = `${bug.project?.identifier || "Unknown Project"}-${
          bug.project_id || "N/A"
        }`;
        const title = bug.title || "";
        const assignee = bug.assignee?.name || "Unknown";
        const reportedBy = bug.tester?.name || "Unknown";

        const devices = (bug.devices || [])
          .map((d) => d.label || d.id)
          .join(", ");
        const browsers = (bug.browsers || [])
          .map((b) => b.label || b.id)
          .join(", ");
        const status = bug.ticket_status?.name || "Unknown";

        data.push([
          ticketId,
          title,
          assignee,
          reportedBy,
          devices,
          browsers,
          status,
        ]);
      });

      setCsvData(data);
      setLoading(false);

      setTimeout(() => {
        const link = document.getElementById("csvLink");
        if (link) link.click();
      }, 0);
    } catch (error) {
      console.error("Error generating CSV:", error);
      setLoading(false);
    }
  };

  const date = moment().format("l");

  if (!bugs || bugs.length < 1) return null;

  return (
    <ExportWrapper id="exportLink">
      <DownloadTitle>Export Bug Options</DownloadTitle>
      {loading ? (
        <div style={{ margin: "0 auto" }} id="form-update-loader"></div>
      ) : (
        <ButtonWrapper>
          <ExportButton onClick={generateCsv} disabled={loading}>
            CSV
          </ExportButton>
          <CSVLink
            id="csvLink"
            filename={`${project?.name || "project"}_bugList_${date}.csv`}
            data={csvData}
            target="_blank"
            style={{ display: "none" }}
          />
          {" | "}
          <a
            href={`/projects/${project.id}/ex_xlsx.xlsx`}
            style={{ width: "unset", padding: "0" }}
          >
            XLSX
          </a>
        </ButtonWrapper>
      )}
    </ExportWrapper>
  );
};

ExportLinks.propTypes = {
  project: PropTypes.object.isRequired,
  bugs: PropTypes.array.isRequired,
};

export default ExportLinks;

// Styled Components
const ExportWrapper = styled.div`
  text-align: right;
`;

const ButtonWrapper = styled.div`
  font-size: 12px;
  font-weight: 700;
`;

const ExportButton = styled.button`
  width: unset;
  padding: 0;
  font-weight: 700;
  color: #039be5;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 12px;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const DownloadTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
`;
